export const validateImageFile = (file) => {
  if (!file) return { isValid: true, error: null };

  const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
  if (!validTypes.includes(file.type)) {
    return { isValid: false, error: "Thumbnail must be a file of type: jpeg, png, jpg, gif." };
  }

  const maxSize = 2 * 1024 * 1024;
  if (file.size > maxSize) {
    return { isValid: false, error: "Thumbnail size cannot exceed 2MB." };
  }

  return { isValid: true, error: null };
};